import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { distinctUntilChanged, startWith, takeUntil } from 'rxjs/operators';

import isEqual from 'lodash-es/isEqual';
import { BaseContainer } from '../../../../../core/common/containers/base.abstract.container';
import { Operand } from '../../../../../core/query/entities/operand.entity';
import { ShFormMultiSelectModule } from '../../../../../form-controls/components/form-multi-select/form-multi-select.module';
import { MultiFormSelectOptions } from '../../../../../form-controls/entities/multi-form-select-options.entity';
import { AdvancedSearchDialogTranslations } from '../../../entities/i18n/advanced-search-translations.entity';

@Component({
    standalone: true,
    selector: 'sh-advanced-search-row-include',
    templateUrl: './advanced-search-row-include.component.html',
    imports: [ShFormMultiSelectModule]
})
export class ShAdvancedSearchRowIncludeComponent extends BaseContainer implements OnInit {
    public options: MultiFormSelectOptions;

    @Input() i18n: AdvancedSearchDialogTranslations;
    @Input() id!: string;
    @Input() label!: string;
    @Input() isHeader = false;
    @Input() control!: UntypedFormControl;

    internalControl: UntypedFormControl = new UntypedFormControl();

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.options = {
            options: [
                { label: this.i18n.includeExclude.include, value: Operand.Include },
                { label: this.i18n.includeExclude.exclude, value: Operand.Exclude }
            ],
            isLiveData: false
        };

        this.initInternalControlValueChangesListener();
        this.initExternalControlValueChangesListener();
    }

    private initInternalControlValueChangesListener(): void {
        this.internalControl.valueChanges
            .pipe(distinctUntilChanged(isEqual), takeUntil(this.destroy$))
            .subscribe((value: string[] | null) => this.control.setValue(value && value.length > 0 ? value[0] : null));
    }

    private initExternalControlValueChangesListener(): void {
        this.control.valueChanges
            .pipe(startWith(this.control.value), distinctUntilChanged(isEqual), takeUntil(this.destroy$))
            .subscribe((value: string) => this.internalControl.setValue(value ? [value] : []));
    }
}
